module.exports = __webpack_public_path__ + "static/img/th.4b0b233c.png";